import React, { useState } from "react";
import { Auth } from "aws-amplify";
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../lib/contextLib";
import { useFormFields } from "../lib/hooksLib";
import { onError } from "../lib/errorLib";
import { Link } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const { userHasAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: ""
  });

  function validateForm() {
    return fields.email.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
	const newPassword=fields.password;
      await Auth.signIn(fields.email, fields.password)
	.then(user => {
	  if (user.challengeName === 'NEW_PASSWORD_REQUIRED'){
            //const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
	    user.completeNewPasswordChallenge(
                newPassword,
		user.challengeParam.requiredAttributes, 
		{
      onSuccess: function (session) {
            userHasAuthenticated(true);
      },
      onFailure: function (err) {
        console.log('completeNewPassword failure', err);
      }		
		});

	  } else {
            userHasAuthenticated(true);
	  }
	});
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  }

  return (
    <div className="col-md-4 offset-md-4">
      <div className="card-body">

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3"  size="lg" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            value={fields.email}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group className="mb-3"  size="lg" controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
        </Form.Group>
	<Form.Group className="mb-3">	
	  <Link to="/reset">Forgot password?</Link>
	</Form.Group>
        <LoaderButton
          block
          size="lg"
          className="btn btn-success"
          type="submit"
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          Login
        </LoaderButton>
      </Form>
    </div>
  </div>
  );
}
